import { z } from 'zod'
import type { EtherscanClient } from './client'

type GetBlockNumberByTimestampParameters = {
  client: EtherscanClient
  /** Unix timestamp in seconds */
  timestamp: number
  closest?: 'before' | 'after'
  headers?: Record<string, string>
}

const resultSchema = z.string().regex(/^\d+$/).transform(Number)

/** {@link https://docs.etherscan.io/api-endpoints/blocks#get-block-number-by-timestamp} */
export const getBlockNumberByTimestamp = async ({
  client,
  timestamp,
  closest = 'before',
  headers,
}: GetBlockNumberByTimestampParameters) => {
  const result = await client.get({
    path: '',
    query: {
      module: 'block',
      action: 'getblocknobytime',
      timestamp: timestamp.toString(),
      closest,
    },
    resultSchema,
    headers,
  })
  return result
}
